import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            观众热评
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自追剧小伙伴的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {commentsData.map((item) => (
            <div
              key={item.name}
              className="rounded-2xl bg-background-50 border border-background-200/60 p-5"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="text-sm font-heading font-bold text-foreground-950 truncate">{item.name}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {item.likes}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">回复</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}